module.exports = __webpack_public_path__ + "static/media/YB5M03_4.8f51ccbb.jpg";